import React from "react";

export default function RichTextEditorLoadingSpinner({ isPopUpSpinner }) {
  return (
    <div
      className={`page-loading-spinner ${
        isPopUpSpinner && "pop-spinner-container"
      }`}
    >
      <div className="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
